import { getContext, setContext } from 'svelte';

export class TabsContext {
	activeTab: string = $state('');
}

export const TABS_CONTEXT_KEY = Symbol('tabs');

export function getTabsContext() {
	return getContext<TabsContext>(TABS_CONTEXT_KEY);
}

export function setTabsContext(ctx: TabsContext) {
	setContext(TABS_CONTEXT_KEY, ctx);
}

export class TabNavContext {
	activeTab: string = $state('');
	onchange: (id: string) => void = () => {};
	mode: 'button' | 'href' = $state('button');
	baseURL: string = $state('');
	orientation: 'horizontal' | 'vertical' | 'responsive' = $state('horizontal');
	autoHideLabels: boolean;
}

export const TAB_NAV_CONTEXT_KEY = Symbol('tab-nav');

export function getTabNavContext() {
	return getContext<TabNavContext>(TAB_NAV_CONTEXT_KEY);
}

export function setTabNavContext(ctx: TabNavContext) {
	setContext(TAB_NAV_CONTEXT_KEY, ctx);
}
